export class OrgAffiliationTypeConst {
  public static MAJOR_OIL = "2";
}
